<div [formGroup]='inputForm' class='container'>
  <h4>Account default email address: {{ emailAddress }}</h4>
  <div class='row'>
    <div class='col col-12'>
      <mat-form-field class='w-100'>
        <mat-label>Notification emails:</mat-label>
        <input
          formControlName='emails'
          matInput
          placeholder='Enter emails separated by commas' />
      </mat-form-field>
    </div>
  </div>
  <div class='row'>
    <div class='col col-12'>
      <mat-checkbox class='w-100' formControlName='notification'
      >Set this at the notification emails address.
      </mat-checkbox
      >
      <mat-checkbox class='w-100 mt-5' formControlName='forward'
      ><span class='forward-checkbox-label'>Set this as the forward email address. <br/>
      <span class='text-muted forward-checkbox-hint'>(Set this as the forward email address. If turned ON, the submitted email addresses will be used for both the standard forward action AND the functionality "Forwarding of incoming messages for disabled accounts")</span></span>
      </mat-checkbox
      >
    </div>
  </div>
  <p *ngIf='testStatus' class='test-notification-status mt-3'>{{ testStatus }}</p>
  <p *ngIf='deliveredStatus' class='test-notification-status test-notification-status--delivered' [class.mt-3]='!testStatus'>{{ deliveredStatus }}</p>
  <p *ngIf='failedStatus' class='test-notification-status test-notification-status--failed' [class.test-notification-status--lead]='!testStatus && !deliveredStatus'>{{ failedStatus }}</p>
</div>
